import React, { useState, useEffect } from 'react';
import AnimatedLayout from '../../components/animatedLetters/AnimatedLayout';
import { ContactSection } from './contactStyle';
import telescope from '../../assets/icons/telescope.svg';
import useElementOnScreen from '../../utils/useElementOnScreen';
import useSecElementOnScreen from '../../utils/useSecElementOnScreen';

const ContactLayout = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const { name, email, subject, message } = formData;

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [itemRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  });
  const [itemTwoRef, isInView] = useSecElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  });
  const [letters, setLetters] = useState('text-animate');

  useEffect(() => {
    setTimeout(() => {
      setLetters('text-animate-hover');
    }, 4000);
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <ContactSection isVisible={isVisible} isInView={isInView}>
        <div className='text-zone'>
          <div className='trans-text' ref={itemRef}>
            <h1>
              <AnimatedLayout
                letterClass={letters}
                strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                idx={30}
              />
            </h1>
            <p>
              I am interested in freelance opportunities especially ambitious or
              large projects. However, if you have other request or question,
              don't hesitate to contact me using the form below.
            </p>
          </div>

          <div className='grid-2'>
            <div className='contact-form' ref={itemTwoRef}>
              <form onSubmit={handleSubmit}>
                <ul>
                  <li className='half'>
                    <input
                      type='text'
                      name='name'
                      placeholder='Name'
                      required
                      value={name}
                      onChange={handleChange}
                    />
                  </li>
                  <li className='half'>
                    <input
                      type='text'
                      name='email'
                      placeholder='Email'
                      required
                      value={email}
                      onChange={handleChange}
                    />
                  </li>
                  <li>
                    <input
                      type='text'
                      name='subject'
                      placeholder='Subject'
                      required
                      value={subject}
                      onChange={handleChange}
                    />
                  </li>
                  <li>
                    <textarea
                      placeholder='message'
                      name='message'
                      required
                      value={message}
                      onChange={handleChange}
                    ></textarea>
                  </li>
                  <li>
                    <input
                      type='submit'
                      value='SEND'
                      className='flat-button'
                      onClick={handleSubmit}
                    />
                  </li>
                </ul>
              </form>
            </div>
            <div className='contact-img'>
              <img src={telescope} alt='' />
            </div>
          </div>
        </div>
      </ContactSection>
    </>
  );
};

export default ContactLayout;
